import { NotificationTypes } from 'components/Toast/constants';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';
import React, { createContext, useContext, useEffect, useState } from 'react';
import {
	getApVendorDBClassificationThreshold,
	updateApVendorDBClassificationThreshold,
} from 'utils/apiRequests';

const ClassificationThresholdContext = createContext();

export const ClassificationThresholdProvider = ({ children }) => {
	const [thresholdValue, setThresholdValue] = useState(null);
	const [isThresholdSaving, setIsThresholdSaving] = useState(false);
	const { showToast } = useToastMessageContext();

	useEffect(() => {
		const getThresholdValue = async () => {
			const response = await getApVendorDBClassificationThreshold();
			if (response.succeeded) {
				if (response.data.threshold !== null) {
					setThresholdValue(response.data.threshold);
				}
			}
		};
		getThresholdValue();
	}, []);

	const onSaveThreshold = async () => {
		setIsThresholdSaving(true);
		const bodyParam = {
			threshold: thresholdValue,
		};
		const response = await updateApVendorDBClassificationThreshold(bodyParam);
		if (response.succeeded) {
			setIsThresholdSaving(false);
			showToast('Threshold saved successfully.', NotificationTypes.success);
			return true;
		} else {
			showToast('Threshold not saved.', NotificationTypes.danger);
			setIsThresholdSaving(false);
			return false;
		}
	};

	return (
		<>
			{thresholdValue !== null && (
				<ClassificationThresholdContext.Provider
					value={{
						thresholdValue,
						isThresholdSaving,
						setThresholdValue,
						onSaveThreshold,
					}}
				>
					{children}
				</ClassificationThresholdContext.Provider>
			)}
		</>
	);
};

export const useClassificationThresholdContext = () => {
	return useContext(ClassificationThresholdContext);
};
